import { render } from "./UpdatePreference.vue?vue&type=template&id=7d373fe4"
import script from "./UpdatePreference.vue?vue&type=script&lang=js"
export * from "./UpdatePreference.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__